/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseMediaWithScrollableTextFragment, MediaWithScrollableTextFragment, FullMediaWithScrollableTextFragment} from '@amblique/contentful/app/contentful/fragments/media-with-scrollable-text';

/**
 * Get a single MediaWithScrollableText by ID (base - scalars only)
 */
export const getBaseMediaWithScrollableTextById = gql`
  ${BaseMediaWithScrollableTextFragment}

  query GetBaseMediaWithScrollableTextById($id: String!, $locale: String!, $preview: Boolean) {
    mediaWithScrollableText(id: $id, locale: $locale, preview: $preview) {
      ...BaseMediaWithScrollableTextFragment
    }
  }
`;

/**
 * Get a single MediaWithScrollableText by ID (standard - 1 level deep)
 */
export const getMediaWithScrollableTextById = gql`
  ${MediaWithScrollableTextFragment}

  query GetMediaWithScrollableTextById($id: String!, $locale: String!, $preview: Boolean) {
    mediaWithScrollableText(id: $id, locale: $locale, preview: $preview) {
      ...MediaWithScrollableTextFragment
    }
  }
`;

/**
 * Get a single MediaWithScrollableText by ID (full - 2 levels deep)
 */
export const getFullMediaWithScrollableTextById = gql`
  ${FullMediaWithScrollableTextFragment}

  query GetFullMediaWithScrollableTextById($id: String!, $locale: String!, $preview: Boolean) {
    mediaWithScrollableText(id: $id, locale: $locale, preview: $preview) {
      ...FullMediaWithScrollableTextFragment
    }
  }
`;

/**
 * Get all MediaWithScrollableText entries with pagination (base - scalars only)
 */
export const getBaseMediaWithScrollableTexts = gql`
  ${BaseMediaWithScrollableTextFragment}

  query GetBaseMediaWithScrollableTexts(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [MediaWithScrollableTextOrder]
    $where: MediaWithScrollableTextFilter
    $preview: Boolean
  ) {
    mediaWithScrollableTextCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseMediaWithScrollableTextFragment
      }
    }
  }
`;

/**
 * Get all MediaWithScrollableText entries with pagination (standard - 1 level deep)
 */
export const getMediaWithScrollableTexts = gql`
  ${MediaWithScrollableTextFragment}

  query GetMediaWithScrollableTexts(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [MediaWithScrollableTextOrder]
    $where: MediaWithScrollableTextFilter
    $preview: Boolean
  ) {
    mediaWithScrollableTextCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...MediaWithScrollableTextFragment
      }
    }
  }
`;

/**
 * Get all MediaWithScrollableText entries with pagination (full - 2 levels deep)
 */
export const getFullMediaWithScrollableTexts = gql`
  ${FullMediaWithScrollableTextFragment}

  query GetFullMediaWithScrollableTexts(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [MediaWithScrollableTextOrder]
    $where: MediaWithScrollableTextFilter
    $preview: Boolean
  ) {
    mediaWithScrollableTextCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullMediaWithScrollableTextFragment
      }
    }
  }
`;
